import { createContext, useContext, useState, ReactNode, useCallback } from 'react';

export type Lang = 'en' | 'pl';

const translations = {
  nav_home: { en: 'Home', pl: 'Strona główna' },
  nav_login: { en: 'Log In', pl: 'Zaloguj się' },
  nav_open_account: { en: 'Open Account', pl: 'Otwórz rachunek' },
  nav_services: { en: 'Services', pl: 'Usługi' },
  nav_plans: { en: 'Plans', pl: 'Plany' },
  nav_faq: { en: 'FAQ', pl: 'FAQ' },
  hero_title: { en: 'Banking for a new era', pl: 'Bankowość nowej ery' },
  hero_subtitle: { en: 'Born in London. Built for the world.', pl: 'Zrodzona w Londynie. Stworzona dla świata.' },
  hero_cta_primary: { en: 'Open Account', pl: 'Otwórz rachunek' },
  hero_cta_secondary: { en: 'Learn More', pl: 'Dowiedz się więcej' },
  features_title: { en: 'Features', pl: 'Funkcje' },
  services_title: { en: 'Our Services', pl: 'Nasze usługi' },
  plans_title: { en: 'Choose your plan', pl: 'Wybierz swój plan' },
  faq_title: { en: 'Frequently Asked Questions', pl: 'Najczęściej zadawane pytania' },
  footer_company: { en: 'Company', pl: 'Firma' },
  footer_legal: { en: 'Legal', pl: 'Prawne' },
  footer_contact: { en: 'Contact', pl: 'Kontakt' },
  login_title: { en: 'Welcome back', pl: 'Witaj ponownie' },
  login_email: { en: 'Email', pl: 'E-mail' },
  login_password: { en: 'Password', pl: 'Hasło' },
  login_submit: { en: 'Sign In', pl: 'Zaloguj się' },
  login_no_account: { en: "Don't have an account?", pl: 'Nie masz konta?' },
  register_title: { en: 'Open your account', pl: 'Otwórz swoje konto' },
  register_step1: { en: 'Personal Details', pl: 'Dane osobowe' },
  register_step2: { en: 'Address & Documents', pl: 'Adres i dokumenty' },
  register_step3: { en: 'Verification', pl: 'Weryfikacja' },
  register_submit: { en: 'Open Account', pl: 'Otwórz rachunek' },
  dashboard_welcome: { en: 'Welcome', pl: 'Witaj' },
  dashboard_balance: { en: 'Balance', pl: 'Saldo' },
  dashboard_account_number: { en: 'Account Number', pl: 'Numer konta' },
  dashboard_transactions: { en: 'Transactions', pl: 'Transakcje' },
  dashboard_cards: { en: 'Cards', pl: 'Karty' },
  dashboard_transfer: { en: 'Transfer', pl: 'Przelew' },
  dashboard_notifications: { en: 'Notifications', pl: 'Powiadomienia' },
  dashboard_profile: { en: 'Profile', pl: 'Profil' },
  dashboard_settings: { en: 'Settings', pl: 'Ustawienia' },
  dash_good_morning: { en: 'Good morning', pl: 'Dzień dobry' },
  dash_good_afternoon: { en: 'Good afternoon', pl: 'Dzień dobry' },
  dash_good_evening: { en: 'Good evening', pl: 'Dobry wieczór' },
  dash_top_up: { en: 'Top Up', pl: 'Doładuj' },
  dash_send_money: { en: 'Send Money', pl: 'Wyślij pieniądze' },
  dash_pay_bills: { en: 'Pay Bills', pl: 'Opłać rachunki' },
  dash_analytics: { en: 'Analytics', pl: 'Analityka' },
  cards_title: { en: 'Cards', pl: 'Karty' },
  cards_virtual: { en: 'Virtual', pl: 'Wirtualna' },
  cards_physical: { en: 'Physical', pl: 'Fizyczna' },
  cards_freeze: { en: 'Freeze', pl: 'Zamroź' },
  cards_unfreeze: { en: 'Unfreeze', pl: 'Odmroź' },
  tx_title: { en: 'Transactions', pl: 'Transakcje' },
  tx_all: { en: 'All', pl: 'Wszystkie' },
  tx_income: { en: 'Income', pl: 'Przychody' },
  tx_expense: { en: 'Expenses', pl: 'Wydatki' },
  transfer_title: { en: 'Transfer Money', pl: 'Przelej pieniądze' },
  transfer_to: { en: 'Send to', pl: 'Wyślij do' },
  transfer_amount: { en: 'Amount', pl: 'Kwota' },
  transfer_submit: { en: 'Send Transfer', pl: 'Wyślij przelew' },
  notif_title: { en: 'Notifications', pl: 'Powiadomienia' },
  notif_empty: { en: 'No notifications', pl: 'Brak powiadomień' },
  profile_title: { en: 'Profile', pl: 'Profil' },
  profile_edit: { en: 'Edit Profile', pl: 'Edytuj profil' },
  settings_title: { en: 'Settings', pl: 'Ustawienia' },
  settings_language: { en: 'Language', pl: 'Język' },
  settings_theme: { en: 'Theme', pl: 'Motyw' },
  settings_notifications: { en: 'Notifications', pl: 'Powiadomienia' },
  admin_clients: { en: 'Clients', pl: 'Klienci' },
  admin_transactions: { en: 'Transactions', pl: 'Transakcje' },
  admin_notifications: { en: 'Notifications', pl: 'Powiadomienia' },
  admin_settings: { en: 'Settings', pl: 'Ustawienia' },
  admin_dashboard: { en: 'Dashboard', pl: 'Panel główny' },
  kyc_pending: { en: 'Pending', pl: 'Oczekuje' },
  kyc_verified: { en: 'Verified', pl: 'Zweryfikowane' },
  kyc_rejected: { en: 'Rejected', pl: 'Odrzucone' },
  kyc_submitted: { en: 'Submitted', pl: 'Przesłane' },
  plan_standard: { en: 'Standard', pl: 'Standard' },
  plan_plus: { en: 'Plus', pl: 'Plus' },
  plan_premium: { en: 'Premium', pl: 'Premium' },
  plan_metal: { en: 'Metal', pl: 'Metal' },
  btn_save: { en: 'Save', pl: 'Zapisz' },
  btn_cancel: { en: 'Cancel', pl: 'Anuluj' },
  btn_close: { en: 'Close', pl: 'Zamknij' },
  btn_confirm: { en: 'Confirm', pl: 'Potwierdź' },
  loading: { en: 'Loading...', pl: 'Ładowanie...' },
  error_generic: { en: 'An error occurred', pl: 'Wystąpił błąd' },
  success_generic: { en: 'Success', pl: 'Sukces' },
  logout: { en: 'Sign Out', pl: 'Wyloguj się' },
  nav_features: { en: 'Features', pl: 'Funkcje' },
  nav_security: { en: 'Security', pl: 'Bezpieczeństwo' },
  nav_about: { en: 'About', pl: 'O nas' },
  nav_contact: { en: 'Contact', pl: 'Kontakt' },
  hero_cta: { en: 'Open a free account', pl: 'Otwórz darmowe konto' },
  hero_open_account: { en: 'Open Account', pl: 'Otwórz rachunek' },
  hero_learn_more: { en: 'Learn More', pl: 'Dowiedz się więcej' },
  services_subtitle: { en: 'Everything you need in one place', pl: 'Wszystko czego potrzebujesz w jednym miejscu' },
  service_personal: { en: 'Personal Account', pl: 'Konto osobiste' },
  service_business: { en: 'Business Account', pl: 'Konto firmowe' },
  service_invest: { en: 'Investments', pl: 'Inwestycje' },
  service_crypto: { en: 'Crypto', pl: 'Kryptowaluty' },
  stats_clients: { en: 'Clients', pl: 'Klientów' },
  stats_countries: { en: 'Countries', pl: 'Krajów' },
  stats_uptime: { en: 'Uptime', pl: 'Dostępność' },
  stats_support: { en: '24/7 Support', pl: 'Wsparcie 24/7' },
  security_title: { en: 'Your money is safe', pl: 'Twoje pieniądze są bezpieczne' },
  security_desc: { en: 'Bank-grade security and protection', pl: 'Bezpieczeństwo i ochrona na poziomie bankowym' },
  security_ssl: { en: '256-bit SSL Encryption', pl: 'Szyfrowanie SSL 256-bit' },
  fca_regulated: { en: 'FCA Regulated', pl: 'Regulowany przez FCA' },
  fscs_protected: { en: 'FSCS Protected up to £85,000', pl: 'Ochrona FSCS do £85,000' },
  footer_rights: { en: '© 2026 CYF SOLUTION LTD. All rights reserved.', pl: '© 2026 CYF SOLUTION LTD. Wszelkie prawa zastrzeżone.' },
  footer_company_name: { en: 'CYF SOLUTION LTD', pl: 'CYF SOLUTION LTD' },
  layout_british_bank: { en: 'British Bank', pl: 'Brytyjski Bank' },
  layout_admin_panel: { en: 'Admin Panel', pl: 'Panel administracyjny' },
  login_subtitle: { en: 'Sign in to your account', pl: 'Zaloguj się do swojego konta' },
  register_subtitle: { en: 'Join thousands of satisfied customers', pl: 'Dołącz do tysięcy zadowolonych klientów' },
  register_step4: { en: 'Choose Plan', pl: 'Wybierz plan' },
  register_first_name: { en: 'First Name', pl: 'Imię' },
  register_last_name: { en: 'Last Name', pl: 'Nazwisko' },
  register_email: { en: 'Email', pl: 'E-mail' },
  register_phone: { en: 'Phone', pl: 'Telefon' },
  register_dob: { en: 'Date of Birth', pl: 'Data urodzenia' },
  register_nationality: { en: 'Nationality', pl: 'Narodowość' },
  register_address: { en: 'Address', pl: 'Adres' },
  register_city: { en: 'City', pl: 'Miasto' },
  register_postcode: { en: 'Postcode', pl: 'Kod pocztowy' },
  register_country: { en: 'Country', pl: 'Kraj' },
  register_next: { en: 'Next', pl: 'Dalej' },
  register_back: { en: 'Back', pl: 'Wstecz' },
  register_has_account: { en: 'Already have an account?', pl: 'Masz już konto?' },
  dash_title: { en: 'Dashboard', pl: 'Panel główny' },
  dash_available: { en: 'Available', pl: 'Dostępne' },
  dash_account_number: { en: 'Account Number', pl: 'Numer konta' },
  dash_sort_code: { en: 'Sort Code', pl: 'Kod sortowania' },
  dash_iban: { en: 'IBAN', pl: 'IBAN' },
  dash_currency: { en: 'Currency', pl: 'Waluta' },
  dash_top_up2: { en: 'Top Up', pl: 'Doładuj' },
  dash_send: { en: 'Send', pl: 'Wyślij' },
  dash_receive: { en: 'Receive', pl: 'Odbierz' },
  dash_cards: { en: 'Cards', pl: 'Karty' },
  dash_recent_tx: { en: 'Recent Transactions', pl: 'Ostatnie transakcje' },
  dash_no_tx: { en: 'No transactions yet', pl: 'Brak transakcji' },
  dash_view_all: { en: 'View All', pl: 'Zobacz wszystkie' },
  dash_client: { en: 'Client', pl: 'Klient' },
  dash_welcome_back: { en: 'Welcome back', pl: 'Witaj ponownie' },
  dash_savings_rate: { en: 'Savings Rate', pl: 'Stopa oszczędności' },
  dash_account_status: { en: 'Account Status', pl: 'Status konta' },
  dash_status_active: { en: 'Active', pl: 'Aktywne' },
  dash_status_frozen: { en: 'Frozen', pl: 'Zamrożone' },
  dash_account_details: { en: 'Account Details', pl: 'Szczegóły konta' },
  dash_frozen_warning: { en: 'Account is frozen. Please contact support.', pl: 'Konto jest zamrożone. Skontaktuj się z obsługą.' },
  dash_kyc_pending: { en: 'KYC Pending', pl: 'KYC oczekuje' },
  dash_kyc_submitted: { en: 'KYC Submitted', pl: 'KYC przesłane' },
  dash_kyc_rejected: { en: 'KYC Rejected', pl: 'KYC odrzucone' },
  dash_kyc_action: { en: 'Complete KYC', pl: 'Uzupełnij KYC' },
  tx_expenses: { en: 'Expenses', pl: 'Wydatki' },
  tx_shopping: { en: 'Shopping', pl: 'Zakupy' },
  tx_food: { en: 'Food', pl: 'Jedzenie' },
  tx_transport: { en: 'Transport', pl: 'Transport' },
  tx_health: { en: 'Health', pl: 'Zdrowie' },
  tx_entertainment: { en: 'Entertainment', pl: 'Rozrywka' },
  tx_utilities: { en: 'Utilities', pl: 'Rachunki' },
  tx_transfer: { en: 'Transfer', pl: 'Przelew' },
  tx_other: { en: 'Other', pl: 'Inne' },
  tx_date: { en: 'Date', pl: 'Data' },
  tx_description: { en: 'Description', pl: 'Opis' },
  tx_amount: { en: 'Amount', pl: 'Kwota' },
  tx_status: { en: 'Status', pl: 'Status' },
  tx_type: { en: 'Type', pl: 'Typ' },
  tx_category: { en: 'Category', pl: 'Kategoria' },
  tx_balance_after: { en: 'Balance After', pl: 'Saldo po' },
  tx_no_transactions: { en: 'No transactions', pl: 'Brak transakcji' },
  cards_subtitle: { en: 'Manage your cards', pl: 'Zarządzaj swoimi kartami' },
  cards_card_number: { en: 'Card Number', pl: 'Numer karty' },
  cards_expiry: { en: 'Expiry', pl: 'Ważność' },
  cards_holder: { en: 'Card Holder', pl: 'Posiadacz karty' },
  cards_block: { en: 'Block', pl: 'Zablokuj' },
  cards_order_physical: { en: 'Order Physical Card', pl: 'Zamów kartę fizyczną' },
  cards_order_virtual: { en: 'Order Virtual Card', pl: 'Zamów kartę wirtualną' },
  cards_security: { en: 'Security', pl: 'Bezpieczeństwo' },
  transfer_recipient: { en: 'Recipient', pl: 'Odbiorca' },
  transfer_account_number: { en: 'Account Number', pl: 'Numer konta' },
  transfer_sort_code: { en: 'Sort Code', pl: 'Kod sortowania' },
  transfer_reference: { en: 'Reference', pl: 'Tytuł' },
  transfer_category: { en: 'Category', pl: 'Kategoria' },
  transfer_success: { en: 'Transfer successful', pl: 'Przelew wykonany' },
  transfer_insufficient: { en: 'Insufficient balance', pl: 'Niewystarczające saldo' },
  notif_no_notifications: { en: 'No notifications', pl: 'Brak powiadomień' },
  notif_mark_read: { en: 'Mark as read', pl: 'Oznacz jako przeczytane' },
  profile_personal: { en: 'Personal Information', pl: 'Informacje osobiste' },
  profile_kyc: { en: 'KYC Status', pl: 'Status KYC' },
  profile_save: { en: 'Save Changes', pl: 'Zapisz zmiany' },
  profile_first_name: { en: 'First Name', pl: 'Imię' },
  profile_last_name: { en: 'Last Name', pl: 'Nazwisko' },
  profile_email: { en: 'Email', pl: 'E-mail' },
  profile_phone: { en: 'Phone', pl: 'Telefon' },
  profile_address: { en: 'Address', pl: 'Adres' },
  profile_city: { en: 'City', pl: 'Miasto' },
  profile_postcode: { en: 'Postcode', pl: 'Kod pocztowy' },
  profile_country: { en: 'Country', pl: 'Kraj' },
  profile_dob: { en: 'Date of Birth', pl: 'Data urodzenia' },
  settings_account_plan: { en: 'Account Plan', pl: 'Plan konta' },
  settings_current_plan: { en: 'Current Plan', pl: 'Aktualny plan' },
  settings_view_plans: { en: 'View Plans', pl: 'Zobacz plany' },
  settings_security: { en: 'Security', pl: 'Bezpieczeństwo' },
  theme_light: { en: 'Light', pl: 'Jasny' },
  theme_dark: { en: 'Dark', pl: 'Ciemny' },
  good_morning: { en: 'Good morning', pl: 'Dzień dobry' },
  good_afternoon: { en: 'Good afternoon', pl: 'Dzień dobry' },
  good_evening: { en: 'Good evening', pl: 'Dobry wieczór' },
  access_denied_title: { en: 'Access Denied', pl: 'Brak dostępu' },
  access_denied_desc: { en: 'You do not have permission to access this page', pl: 'Nie masz uprawnień do tej strony' },
  access_denied_back: { en: 'Back to Home', pl: 'Powrót do strony głównej' },
  admin_dashboard_title: { en: 'Admin Dashboard', pl: 'Panel administracyjny' },
  admin_clients_title: { en: 'Clients', pl: 'Klienci' },
  admin_total_clients: { en: 'Total Clients', pl: 'Wszyscy klienci' },
  admin_verified: { en: 'Verified', pl: 'Zweryfikowani' },
  admin_pending_kyc: { en: 'Pending KYC', pl: 'Oczekujące KYC' },
  admin_total_balance: { en: 'Total Balance', pl: 'Łączne saldo' },
  admin_recent_registrations: { en: 'Recent Registrations', pl: 'Ostatnie rejestracje' },
  admin_credit: { en: 'Credit', pl: 'Zasilenie' },
  admin_debit: { en: 'Debit', pl: 'Obciążenie' },
  admin_freeze: { en: 'Freeze', pl: 'Zamroź' },
  admin_unfreeze: { en: 'Unfreeze', pl: 'Odmroź' },
  admin_send_notification: { en: 'Send Notification', pl: 'Wyślij powiadomienie' },
  admin_send_sms: { en: 'Send SMS', pl: 'Wyślij SMS' },
  admin_generate_statement: { en: 'Generate Statement', pl: 'Generuj wyciąg' },
  admin_amount: { en: 'Amount', pl: 'Kwota' },
  admin_note: { en: 'Note', pl: 'Notatka' },
  admin_notification_title: { en: 'Notification Title', pl: 'Tytuł powiadomienia' },
  admin_notification_message: { en: 'Message', pl: 'Wiadomość' },
  admin_sms_message: { en: 'SMS Message', pl: 'Wiadomość SMS' },
  admin_submit: { en: 'Submit', pl: 'Wyślij' },
  admin_success: { en: 'Success', pl: 'Sukces' },
  admin_error: { en: 'Error', pl: 'Błąd' },
  sign_out: { en: 'Sign Out', pl: 'Wyloguj się' },
  legal_title: { en: 'Legal Information', pl: 'Informacje prawne' },
  legal_company: { en: 'CYF SOLUTION LTD', pl: 'CYF SOLUTION LTD' },
  legal_fca: { en: 'Regulated by FCA', pl: 'Regulowany przez FCA' },
  legal_fscs: { en: 'FSCS Protected up to £85,000', pl: 'Ochrona FSCS do £85,000' },
  admin_hint: { en: 'Admin shortcut hint', pl: 'Skrót do panelu admina' },
  layout_client_panel: { en: 'My Account', pl: 'Moje konto' },
  hero_desc: { en: 'Open your CYF24 Bank account in minutes. No hidden fees, no paperwork. Regulated by the FCA, FSCS protected up to £85,000.', pl: 'Otwórz konto CYF24 Bank w kilka minut. Brak ukrytych opłat, brak papierologii. Regulowany przez FCA, ochrona FSCS do £85,000.' },
  hero_cta2: { en: 'Discover Features', pl: 'Odkryj funkcje' },
  hero_card_balance: { en: 'Total Balance', pl: 'Łączne saldo' },
  hero_card_subscription: { en: 'Subscription', pl: 'Subskrypcja' },
  hero_card_salary: { en: 'Salary', pl: 'Wynagrodzenie' },
  hero_card_income: { en: 'Income', pl: 'Przychód' },
  hero_card_shopping: { en: 'Shopping', pl: 'Zakupy' },
  features_subtitle: { en: 'Everything you need for modern banking', pl: 'Wszystko czego potrzebujesz do nowoczesnej bankowości' },
  feat_instant: { en: 'Instant Transfers', pl: 'Natychmiastowe przelewy' },
  feat_instant_desc: { en: 'Send money in seconds, 24/7, anywhere in the world.', pl: 'Wysyłaj pieniądze w sekundy, całą dobę, wszędzie na świecie.' },
  feat_secure: { en: 'Bank-grade Security', pl: 'Bezpieczeństwo bankowe' },
  feat_secure_desc: { en: '256-bit encryption and biometric authentication protect your assets.', pl: 'Szyfrowanie 256-bit i uwierzytelnianie biometryczne chronią Twoje środki.' },
  feat_global: { en: 'Global Payments', pl: 'Płatności globalne' },
  feat_global_desc: { en: 'Pay in 150+ currencies with best exchange rates.', pl: 'Płać w 150+ walutach po najlepszych kursach wymiany.' },
  feat_mobile: { en: 'Mobile First', pl: 'Przede wszystkim mobilnie' },
  feat_mobile_desc: { en: 'Full banking experience on your phone, always with you.', pl: 'Pełna bankowość na telefonie, zawsze przy Tobie.' },
  feat_cards: { en: 'Smart Cards', pl: 'Inteligentne karty' },
  feat_cards_desc: { en: 'Virtual and physical cards with instant freezing and spending controls.', pl: 'Karty wirtualne i fizyczne z natychmiastowym zamrażaniem i kontrolą wydatków.' },
  feat_analytics: { en: 'Spending Analytics', pl: 'Analityka wydatków' },
  feat_analytics_desc: { en: 'AI-powered insights to help you understand and manage your finances.', pl: 'Statystyki oparte na AI pomagające zarządzać finansami.' },
  srv_personal: { en: 'Personal Account', pl: 'Konto osobiste' },
  srv_personal_desc: { en: 'A full-featured current account with instant notifications, budgeting tools, and a free debit card.', pl: 'Pełnoprawne konto bieżące z natychmiastowymi powiadomieniami, narzędziami budżetowania i darmową kartą debetową.' },
  srv_business: { en: 'Business Account', pl: 'Konto firmowe' },
  srv_business_desc: { en: 'Multi-user business accounts with expense tracking, invoicing, and dedicated support.', pl: 'Firmowe konta wieloosobowe ze śledzeniem wydatków, fakturowaniem i dedykowaną obsługą.' },
  srv_invest: { en: 'Investments', pl: 'Inwestycje' },
  srv_invest_desc: { en: 'Invest in stocks, ETFs, and funds directly from your account with fractional shares.', pl: 'Inwestuj w akcje, ETF i fundusze bezpośrednio z konta z ułamkowymi udziałami.' },
  srv_crypto: { en: 'Crypto', pl: 'Kryptowaluty' },
  srv_crypto_desc: { en: 'Buy, sell, and hold 50+ cryptocurrencies with real-time pricing and instant conversion.', pl: 'Kupuj, sprzedawaj i przechowuj 50+ kryptowalut z wycenami w czasie rzeczywistym.' },
  srv_learn_more: { en: 'Learn more', pl: 'Dowiedz się więcej' },
  testimonials_title: { en: 'What our clients say', pl: 'Co mówią nasi klienci' },
  testimonials_subtitle: { en: 'Thousands of satisfied customers trust CYF24 Bank', pl: 'Tysiące zadowolonych klientów zaufało CYF24 Bank' },
  testimonial1_name: { en: 'James Wilson', pl: 'Jakub Wiśniewski' },
  testimonial1_role: { en: 'Entrepreneur, London', pl: 'Przedsiębiorca, Londyn' },
  testimonial1_text: { en: 'CYF24 Bank has completely transformed how I manage my business finances. The instant transfers and clear analytics are invaluable.', pl: 'CYF24 Bank całkowicie zmienił sposób zarządzania moimi finansami firmowymi. Natychmiastowe przelewy i przejrzyste analizy są bezcenne.' },
  testimonial2_name: { en: 'Sophie Chen', pl: 'Zofia Kowalczyk' },
  testimonial2_role: { en: 'Freelancer, Manchester', pl: 'Freelancer, Warszawa' },
  testimonial2_text: { en: 'The best digital bank I have used. Customer support is always responsive and the app experience is exceptional.', pl: 'Najlepszy bank cyfrowy, z jakiego korzystałam. Obsługa klienta zawsze reaguje, a doświadczenie z aplikacją jest wyjątkowe.' },
  testimonial3_name: { en: 'Michael Burke', pl: 'Michał Brzezinski' },
  testimonial3_role: { en: 'IT Professional, Birmingham', pl: 'Specjalista IT, Kraków' },
  testimonial3_text: { en: 'International transfers at the real exchange rate – this alone makes CYF24 Bank worth it compared to traditional banks.', pl: 'Przelewy międzynarodowe po realnym kursie – samo to sprawia, że CYF24 Bank jest wart więcej niż tradycyjne banki.' },
  plans_subtitle: { en: 'Flexible plans to match your lifestyle and financial goals', pl: 'Elastyczne plany dopasowane do Twojego stylu życia i celów finansowych' },
  plan_get_started: { en: 'Get Started', pl: 'Zacznij' },
  plan_popular: { en: 'Most Popular', pl: 'Najpopularniejszy' },
  security_label: { en: 'Security', pl: 'Bezpieczeństwo' },
  security_fca_desc: { en: 'CYF24 Bank is authorised and regulated by the Financial Conduct Authority (FCA). Your account is fully protected under UK financial regulations.', pl: 'CYF24 Bank jest upoważniony i regulowany przez Financial Conduct Authority (FCA). Twoje konto jest w pełni chronione na mocy brytyjskich przepisów finansowych.' },
  security_fscs_desc: { en: 'Your eligible deposits are protected up to £85,000 by the Financial Services Compensation Scheme (FSCS).', pl: 'Twoje kwalifikowane depozyty są chronione do £85,000 przez Financial Services Compensation Scheme (FSCS).' },
  security_ssl_desc: { en: 'All data is encrypted using military-grade 256-bit SSL encryption. Your privacy and security are our top priority.', pl: 'Wszystkie dane są szyfrowane z użyciem 256-bitowego szyfrowania SSL klasy wojskowej. Twoja prywatność i bezpieczeństwo są naszym priorytetem.' },
  cta_label: { en: 'Get started today', pl: 'Zacznij dziś' },
  cta_title: { en: 'Ready to experience modern banking?', pl: 'Gotowy na nowoczesną bankowość?' },
  cta_desc: { en: 'Join thousands of customers who have already switched to CYF24 Bank. Open your account in just 5 minutes.', pl: 'Dołącz do tysięcy klientów, którzy już przeszli do CYF24 Bank. Otwórz konto w zaledwie 5 minut.' },
  cta_btn: { en: 'Open Free Account', pl: 'Otwórz darmowe konto' },
  cta_footer_note: { en: 'Free account · No hidden fees · FCA Regulated', pl: 'Darmowe konto · Bez ukrytych opłat · Regulowany przez FCA' },
  login_secure_access: { en: 'Secure Access', pl: 'Bezpieczny dostęp' },
  login_security_desc: { en: 'Protected by 256-bit SSL, FCA regulated and FSCS insured', pl: 'Chroniony przez SSL 256-bit, regulowany FCA i ubezpieczony FSCS' },
  login_email_placeholder: { en: 'your@email.com', pl: 'twoj@email.com' },
  login_remember: { en: 'Remember me', pl: 'Zapamiętaj mnie' },
  login_forgot_password: { en: 'Forgot password?', pl: 'Nie pamiętasz hasła?' },
  login_back_home: { en: '← Back to home', pl: '← Powrót na stronę główną' },
  login_error: { en: 'Login error', pl: 'Błąd logowania' },
  login_error_generic: { en: 'Invalid email or password', pl: 'Nieprawidłowy email lub hasło' },
  register_password: { en: 'Password', pl: 'Hasło' },
  reg_first_name: { en: 'First Name', pl: 'Imię' },
  reg_last_name: { en: 'Last Name', pl: 'Nazwisko' },
  reg_phone: { en: 'Phone Number', pl: 'Numer telefonu' },
  reg_dob: { en: 'Date of Birth', pl: 'Data urodzenia' },
  reg_nationality: { en: 'Nationality', pl: 'Narodowość' },
  reg_address1: { en: 'Address Line 1', pl: 'Adres (linia 1)' },
  reg_city: { en: 'City', pl: 'Miasto' },
  reg_postcode: { en: 'Postcode', pl: 'Kod pocztowy' },
  reg_next: { en: 'Next', pl: 'Dalej' },
  reg_back: { en: 'Back', pl: 'Wstecz' },
  footer_description: { en: 'A modern British digital bank, regulated by the FCA and FSCS protected. Banking for everyone, from London to the world.', pl: 'Nowoczesny brytyjski bank cyfrowy, regulowany przez FCA i chroniony przez FSCS. Bankowość dla każdego, z Londynu dla świata.' },
  footer_company_number: { en: 'Company No.', pl: 'Nr firmy' },
  footer_registered: { en: 'Registered in England and Wales. 25 Canada Square, London E14 5LQ', pl: 'Zarejestrowana w Anglii i Walii. 25 Canada Square, Londyn E14 5LQ' },
  footer_products: { en: 'Products', pl: 'Produkty' },
  footer_personal_banking: { en: 'Personal Banking', pl: 'Bankowość osobista' },
  footer_business_banking: { en: 'Business Banking', pl: 'Bankowość firmowa' },
  footer_investments: { en: 'Investments', pl: 'Inwestycje' },
  footer_crypto: { en: 'Crypto', pl: 'Kryptowaluty' },
  footer_legal_info: { en: 'Legal Information', pl: 'Informacje prawne' },
  footer_terms: { en: 'Terms of Service', pl: 'Warunki usługi' },
  footer_privacy: { en: 'Privacy Policy', pl: 'Polityka prywatności' },
  footer_faq: { en: 'FAQ', pl: 'FAQ' },
  footer_fscs: { en: 'CYF SOLUTION LTD is registered in England and Wales (Company No. 15936230). Authorised and regulated by the Financial Conduct Authority.', pl: 'CYF SOLUTION LTD jest zarejestrowana w Anglii i Walii (Nr 15936230). Autoryzowana i regulowana przez Financial Conduct Authority.' },
  footer_fca_fscs: { en: 'Eligible deposits are protected up to £85,000 by the Financial Services Compensation Scheme (FSCS).', pl: 'Kwalifikowane depozyty są chronione do £85,000 przez Financial Services Compensation Scheme (FSCS).' },
  footer_copyright: { en: '© 2026 CYF SOLUTION LTD. All rights reserved.', pl: '© 2026 CYF SOLUTION LTD. Wszelkie prawa zastrzeżone.' },
  cards_active: { en: 'Active', pl: 'Aktywna' },
  cards_active_desc: { en: 'Card is active and ready to use', pl: 'Karta jest aktywna i gotowa do użycia' },
  cards_frozen: { en: 'Frozen', pl: 'Zamrożona' },
  cards_frozen_desc: { en: 'Card is temporarily frozen', pl: 'Karta jest tymczasowo zamrożona' },
  cards_no_cards: { en: 'No cards found', pl: 'Nie znaleziono kart' },
  cards_no_cards_desc: { en: 'You have no active cards. Order one below.', pl: 'Nie masz aktywnych kart. Zamów poniżej.' },
  cards_debit: { en: 'Debit', pl: 'Debetowa' },
  cards_credit: { en: 'Credit', pl: 'Kredytowa' },
  cards_type: { en: 'Card Type', pl: 'Typ karty' },
  cards_network: { en: 'Network', pl: 'Sieć' },
  cards_details: { en: 'Card Details', pl: 'Szczegóły karty' },
  cards_daily_limit: { en: 'Daily Limit', pl: 'Dzienny limit' },
  cards_contactless: { en: 'Contactless', pl: 'Zbliżeniowa' },
  cards_online: { en: 'Online Payments', pl: 'Płatności online' },
  cards_atm: { en: 'ATM Withdrawals', pl: 'Wypłaty z bankomatów' },
  cards_security_3d: { en: '3D Secure', pl: '3D Secure' },
  cards_security_3d_desc: { en: 'Additional authentication for online payments', pl: 'Dodatkowe uwierzytelnienie dla płatności online' },
  cards_security_freeze_desc: { en: 'Instantly freeze your card if lost or stolen', pl: 'Natychmiast zamroź kartę w razie zagubienia lub kradzieży' },
  cards_security_limits: { en: 'Spending Limits', pl: 'Limity wydatków' },
  cards_security_limits_desc: { en: 'Set daily and monthly spending limits', pl: 'Ustaw dzienne i miesięczne limity wydatków' },
  cards_error: { en: 'Error loading cards', pl: 'Błąd ładowania kart' },
  cards_error_desc: { en: 'Could not load card data. Please try again.', pl: 'Nie można załadować danych karty. Spróbuj ponownie.' },
  cards_ordered: { en: 'Card ordered!', pl: 'Karta zamówiona!' },
  cards_ordered_desc: { en: 'Your new card will arrive in 3-5 business days', pl: 'Twoja nowa karta dotrze w ciągu 3-5 dni roboczych' },
  cards_order_error: { en: 'Order failed', pl: 'Zamówienie nieudane' },
  cards_ordering: { en: 'Ordering...', pl: 'Zamawianie...' },
  tx_search: { en: 'Search transactions', pl: 'Szukaj transakcji' },
  tx_export: { en: 'Export', pl: 'Eksportuj' },
  tx_filter_all: { en: 'All', pl: 'Wszystkie' },
  tx_filter_credit: { en: 'Credits', pl: 'Przychody' },
  tx_filter_debit: { en: 'Debits', pl: 'Wydatki' },
  tx_filter_transfer: { en: 'Transfers', pl: 'Przelewy' },
  tx_counterparty: { en: 'Counterparty', pl: 'Kontrahent' },
  tx_net_balance: { en: 'Net Balance', pl: 'Saldo netto' },
  tx_page: { en: 'Page', pl: 'Strona' },
  tx_pending: { en: 'Pending', pl: 'Oczekujące' },
  tx_completed: { en: 'Completed', pl: 'Zakończone' },
  tx_failed: { en: 'Failed', pl: 'Nieudane' },
  tx_status_completed: { en: 'Completed', pl: 'Zakończone' },
  tx_status_pending: { en: 'Pending', pl: 'Oczekujące' },
  tx_status_failed: { en: 'Failed', pl: 'Nieudane' },
  tx_status_reversed: { en: 'Reversed', pl: 'Cofnięte' },
  tx_no_results: { en: 'No transactions found', pl: 'Nie znaleziono transakcji' },
  notif_empty_sub: { en: 'You are all caught up!', pl: 'Jesteś na bieżąco!' },
  notif_mark_all: { en: 'Mark all as read', pl: 'Oznacz wszystkie jako przeczytane' },
  notif_new: { en: 'New', pl: 'Nowe' },
  notif_unread: { en: 'Unread', pl: 'Nieprzeczytane' },
  filter_all: { en: 'All', pl: 'Wszystkie' },
  filter_unread: { en: 'Unread', pl: 'Nieprzeczytane' },
  transfer_account_no: { en: 'Account Number', pl: 'Numer konta' },
  transfer_available: { en: 'Available balance', pl: 'Dostępne saldo' },
  transfer_recipient_name: { en: 'Recipient Name', pl: 'Imię i nazwisko odbiorcy' },
  transfer_recipient_placeholder: { en: 'John Smith', pl: 'Jan Kowalski' },
  transfer_desc_placeholder: { en: 'e.g. Rent, Invoice #123', pl: 'np. Czynsz, Faktura #123' },
  transfer_fill_recipient: { en: 'Please fill in recipient details', pl: 'Uzupełnij dane odbiorcy' },
  transfer_invalid_amount: { en: 'Please enter a valid amount', pl: 'Podaj prawidłową kwotę' },
  transfer_insufficient_balance: { en: 'Insufficient balance', pl: 'Niewystarczające saldo' },
  transfer_invalid_account: { en: 'Invalid account number (8 digits required)', pl: 'Nieprawidłowy numer konta (wymagane 8 cyfr)' },
  transfer_invalid_sort_code: { en: 'Invalid sort code (format: XX-XX-XX)', pl: 'Nieprawidłowy kod sortowania (format: XX-XX-XX)' },
  transfer_processing: { en: 'Processing...', pl: 'Przetwarzanie...' },
  transfer_error: { en: 'Transfer failed. Please try again.', pl: 'Przelew nieudany. Spróbuj ponownie.' },
  transfer_save_ben: { en: 'Save as beneficiary', pl: 'Zapisz jako beneficjenta' },
  transfer_save_tip: { en: 'Save recipient for future transfers', pl: 'Zapisz odbiorcę do przyszłych przelewów' },
  transfer_beneficiaries: { en: 'Saved Beneficiaries', pl: 'Zapisani beneficjenci' },
  transfer_no_beneficiaries: { en: 'No saved beneficiaries yet', pl: 'Brak zapisanych beneficjentów' },
  transfer_saved_ben: { en: 'Beneficiary saved!', pl: 'Beneficjent zapisany!' },
  transfer_ben_deleted: { en: 'Beneficiary removed', pl: 'Beneficjent usunięty' },
  profile_created_at: { en: 'Member since', pl: 'Klient od' },
  profile_password: { en: 'Password', pl: 'Hasło' },
  settings_appearance: { en: 'Appearance', pl: 'Wygląd' },
  settings_change: { en: 'Change', pl: 'Zmień' },
  settings_currency: { en: 'Currency', pl: 'Waluta' },
  settings_email_notifications: { en: 'Email Notifications', pl: 'Powiadomienia e-mail' },
  settings_email_notifications_desc: { en: 'Receive account updates via email', pl: 'Otrzymuj aktualizacje konta przez e-mail' },
  settings_push_notifications: { en: 'Push Notifications', pl: 'Powiadomienia push' },
  settings_push_notifications_desc: { en: 'Receive real-time alerts on your device', pl: 'Otrzymuj powiadomienia w czasie rzeczywistym' },
  settings_plan_free: { en: 'Free', pl: 'Bezpłatny' },
  settings_plan_month: { en: '/month', pl: '/miesiąc' },
  settings_plan_updated: { en: 'Plan updated!', pl: 'Plan zaktualizowany!' },
  settings_privacy_data: { en: 'Privacy & Data', pl: 'Prywatność i dane' },
  settings_download_data: { en: 'Download My Data', pl: 'Pobierz moje dane' },
  settings_download_data_info: { en: 'Get a copy of all your personal data', pl: 'Pobierz kopię wszystkich swoich danych osobowych' },
  settings_delete_account: { en: 'Delete Account', pl: 'Usuń konto' },
  settings_delete_account_warning: { en: 'This action is irreversible. All your data will be permanently deleted.', pl: 'Ta akcja jest nieodwracalna. Wszystkie Twoje dane zostaną trwale usunięte.' },
  settings_delete_account_confirm: { en: 'Are you sure you want to delete your account?', pl: 'Czy na pewno chcesz usunąć swoje konto?' },
  settings_account_deleted: { en: 'Account deleted', pl: 'Konto usunięte' },
  admin_loading: { en: 'Loading...', pl: 'Ładowanie...' },
  admin_sending: { en: 'Sending...', pl: 'Wysyłanie...' },
  admin_logged_in_as_admin: { en: 'Logged in as admin', pl: 'Zalogowany jako administrator' },
  admin_client_name: { en: 'Client Name', pl: 'Nazwa klienta' },
  admin_client_email: { en: 'Email', pl: 'E-mail' },
  admin_client_plan: { en: 'Plan', pl: 'Plan' },
  admin_client_kyc: { en: 'KYC', pl: 'KYC' },
  admin_email_placeholder: { en: 'admin@cyf24.com', pl: 'admin@cyf24.com' },
  admin_no_notifications: { en: 'No notifications sent yet', pl: 'Nie wysłano jeszcze żadnych powiadomień' },
  admin_notification_all_clients: { en: 'All clients', pl: 'Wszyscy klienci' },
  admin_notification_client: { en: 'Specific client', pl: 'Wybrany klient' },
  admin_notification_fill_fields: { en: 'Please fill in all fields', pl: 'Uzupełnij wszystkie pola' },
  admin_notification_message_placeholder: { en: 'Notification message...', pl: 'Treść powiadomienia...' },
  admin_notification_no_clients: { en: 'No clients found', pl: 'Nie znaleziono klientów' },
  admin_notification_recent: { en: 'Recent Notifications', pl: 'Ostatnie powiadomienia' },
  admin_notification_search_clients: { en: 'Search clients...', pl: 'Szukaj klientów...' },
  admin_notification_select_client: { en: 'Select client', pl: 'Wybierz klienta' },
  admin_notification_send: { en: 'Send', pl: 'Wyślij' },
  admin_notification_send_all: { en: 'Send to all clients', pl: 'Wyślij do wszystkich klientów' },
  admin_notification_send_button: { en: 'Send Notification', pl: 'Wyślij powiadomienie' },
  admin_notification_sent_all: { en: 'Notification sent to all clients!', pl: 'Powiadomienie wysłane do wszystkich klientów!' },
  admin_notification_sent_to: { en: 'Notification sent to', pl: 'Powiadomienie wysłane do' },
  admin_notification_single_client: { en: 'Send to one client', pl: 'Wyślij do jednego klienta' },
  admin_notification_title_placeholder: { en: 'Notification title...', pl: 'Tytuł powiadomienia...' },
  admin_notification_to: { en: 'To', pl: 'Do' },
  admin_notification_type: { en: 'Type', pl: 'Typ' },
  admin_notification_type_alert: { en: 'Alert', pl: 'Alert' },
  admin_notification_type_info: { en: 'Info', pl: 'Informacja' },
  admin_notification_type_success: { en: 'Success', pl: 'Sukces' },
  admin_notification_type_warning: { en: 'Warning', pl: 'Ostrzeżenie' },
  admin_notifications_subtitle: { en: 'Send messages to clients', pl: 'Wysyłaj wiadomości do klientów' },
  admin_notifications_title: { en: 'Notifications', pl: 'Powiadomienia' },
  admin_push_notifications: { en: 'Push Notifications', pl: 'Powiadomienia push' },
  admin_push_notifications_desc: { en: 'Enable push notifications for clients', pl: 'Włącz powiadomienia push dla klientów' },
  admin_save_settings: { en: 'Save Settings', pl: 'Zapisz ustawienia' },
  admin_settings_title: { en: 'System Settings', pl: 'Ustawienia systemowe' },
  admin_system_settings: { en: 'System Configuration', pl: 'Konfiguracja systemu' },
  admin_maintenance_mode: { en: 'Maintenance Mode', pl: 'Tryb konserwacji' },
  admin_maintenance_desc: { en: 'Enable maintenance mode to prevent user access', pl: 'Włącz tryb konserwacji, aby uniemożliwić dostęp użytkownikom' },
  admin_auto_kyc: { en: 'Auto-approve KYC', pl: 'Automatyczne zatwierdzanie KYC' },
  admin_auto_kyc_desc: { en: 'Automatically approve KYC submissions', pl: 'Automatycznie zatwierdzaj zgłoszenia KYC' },
  admin_audit_log: { en: 'Audit Log', pl: 'Dziennik audytu' },
  admin_audit_log_desc: { en: 'Keep a detailed log of all admin actions', pl: 'Prowadź szczegółowy dziennik wszystkich działań administratora' },
  admin_grant_rights: { en: 'Grant Admin Rights', pl: 'Nadaj prawa administratora' },
  admin_grant_rights_desc: { en: 'Enter user email to grant admin access', pl: 'Podaj e-mail użytkownika, aby nadać dostęp administratora' },
  admin_grant_warning: { en: 'This user will have full admin access!', pl: 'Ten użytkownik będzie miał pełny dostęp administratora!' },
  admin_grant_button: { en: 'Grant Admin Rights', pl: 'Nadaj prawa' },
  admin_rights_granted: { en: 'Admin rights granted!', pl: 'Prawa administratora nadane!' },
  admin_revoke_rights: { en: 'Revoke Admin Rights', pl: 'Odbierz prawa administratora' },
  admin_revoke_email_placeholder: { en: 'Email of admin to revoke', pl: 'E-mail administratora do odebrania uprawnień' },
  admin_revoke_button: { en: 'Revoke Rights', pl: 'Odbierz prawa' },
  admin_rights_revoked: { en: 'Admin rights revoked!', pl: 'Prawa administratora odebrane!' },
  admin_cannot_revoke_self: { en: 'You cannot revoke your own admin rights', pl: 'Nie możesz odebrać sobie praw administratora' },
  admin_account_not_found: { en: 'Account not found', pl: 'Nie znaleziono konta' },
  admin_actions_recorded: { en: 'Action recorded in audit log', pl: 'Działanie zapisane w dzienniku audytu' },
  admin_tx_title: { en: 'All Transactions', pl: 'Wszystkie transakcje' },
  admin_tx_all_transactions: { en: 'Transaction History', pl: 'Historia transakcji' },
  admin_tx_search_placeholder: { en: 'Search by client or description...', pl: 'Szukaj po kliencie lub opisie...' },
  admin_tx_filter_all: { en: 'All', pl: 'Wszystkie' },
  admin_tx_filter_credit: { en: 'Credits', pl: 'Przychody' },
  admin_tx_filter_debit: { en: 'Debits', pl: 'Wydatki' },
  admin_tx_filter_transfer_in: { en: 'Transfer In', pl: 'Przelew przychodzący' },
  admin_tx_filter_transfer_out: { en: 'Transfer Out', pl: 'Przelew wychodzący' },
  admin_tx_filter_fee: { en: 'Fees', pl: 'Opłaty' },
  admin_tx_filter_interest: { en: 'Interest', pl: 'Odsetki' },
  admin_tx_total_income: { en: 'Total Income', pl: 'Łączne przychody' },
  admin_tx_total_debit: { en: 'Total Debits', pl: 'Łączne wydatki' },
  admin_tx_net_balance: { en: 'Net Balance', pl: 'Saldo netto' },
  admin_tx_unknown_client: { en: 'Unknown Client', pl: 'Nieznany klient' },
  admin_tx_showing: { en: 'Showing', pl: 'Wyświetlanie' },
  admin_tx_of: { en: 'of', pl: 'z' },
  admin_tx_page: { en: 'Page', pl: 'Strona' },
  admin_tx_previous: { en: 'Previous', pl: 'Poprzednia' },
  admin_tx_next: { en: 'Next', pl: 'Następna' },
  legal_subtitle: { en: 'Legal & Compliance Information', pl: 'Informacje prawne i zgodność' },
  legal_company_name: { en: 'Company Name', pl: 'Nazwa firmy' },
  legal_trade_name: { en: 'Trading Name', pl: 'Nazwa handlowa' },
  legal_registration_number: { en: 'Registration Number', pl: 'Numer rejestracyjny' },
  legal_activity_type: { en: 'Activity Type', pl: 'Typ działalności' },
  legal_jurisdiction: { en: 'Jurisdiction', pl: 'Jurysdykcja' },
  legal_regulator: { en: 'Regulator', pl: 'Regulator' },
  legal_regulation: { en: 'Regulation', pl: 'Regulacja' },
  legal_emi_registration: { en: 'EMI Registration', pl: 'Rejestracja EMI' },
  legal_ico_registration: { en: 'ICO Registration', pl: 'Rejestracja ICO' },
  legal_address: { en: 'Registered Address', pl: 'Adres rejestrowy' },
  legal_email: { en: 'Email', pl: 'E-mail' },
  legal_phone: { en: 'Phone', pl: 'Telefon' },
  legal_contact: { en: 'Contact', pl: 'Kontakt' },
  legal_data_controller: { en: 'Data Controller', pl: 'Administrator danych' },
  legal_dpo: { en: 'Data Protection Officer', pl: 'Inspektor ochrony danych' },
  legal_data_protection: { en: 'Data Protection', pl: 'Ochrona danych' },
  legal_documents: { en: 'Legal Documents', pl: 'Dokumenty prawne' },
  legal_terms: { en: 'Terms of Service', pl: 'Warunki usługi' },
  legal_privacy: { en: 'Privacy Policy', pl: 'Polityka prywatności' },
  legal_aml: { en: 'AML Policy', pl: 'Polityka AML' },
  legal_fees: { en: 'Fees & Charges', pl: 'Opłaty i prowizje' },
  legal_cookies: { en: 'Cookie Policy', pl: 'Polityka cookies' },
  legal_compliance: { en: 'Compliance', pl: 'Zgodność' },
  legal_fscs_info: { en: 'Eligible deposits protected up to £85,000 per person under FSCS', pl: 'Kwalifikowane depozyty chronione do £85,000 na osobę przez FSCS' },
  legal_fscs_amount: { en: '£85,000', pl: '£85,000' },
  legal_copyright: { en: '© 2026 CYF SOLUTION LTD. All rights reserved.', pl: '© 2026 CYF SOLUTION LTD. Wszelkie prawa zastrzeżone.' },
  legal_updated: { en: 'Last updated: April 2026', pl: 'Ostatnia aktualizacja: kwiecień 2026' },
  general_loading: { en: 'Loading...', pl: 'Ładowanie...' },
  general_no_data: { en: 'No data available', pl: 'Brak dostępnych danych' },
  cancel: { en: 'Cancel', pl: 'Anuluj' },
  balance: { en: 'Balance', pl: 'Saldo' },
  kyc_status: { en: 'KYC Status', pl: 'Status KYC' },
  time_just_now: { en: 'Just now', pl: 'Właśnie teraz' },
  time_minutes_ago: { en: 'minutes ago', pl: 'minut temu' },
  time_hours_ago: { en: 'hours ago', pl: 'godzin temu' },
  time_days_ago: { en: 'days ago', pl: 'dni temu' },
  admin_add_credit: { en: 'Add Credit', pl: 'Dodaj środki' },
  admin_add_debit: { en: 'Deduct Funds', pl: 'Odejmij środki' },
  admin_verify_kyc: { en: 'Verify KYC', pl: 'Zweryfikuj KYC' },
  admin_add_bank_account: { en: 'Add Bank Account', pl: 'Dodaj konto bankowe' },
  admin_credit_added: { en: 'Credit added successfully', pl: 'Środki dodane pomyślnie' },
  admin_debit_added: { en: 'Funds deducted successfully', pl: 'Środki odjęte pomyślnie' },
  admin_kyc_verified: { en: 'KYC verified successfully', pl: 'KYC zweryfikowane pomyślnie' },
  admin_bank_account_added: { en: 'Bank account added successfully', pl: 'Konto bankowe dodane pomyślnie' },
  admin_enter_amount: { en: 'Enter amount', pl: 'Podaj kwotę' },
  admin_enter_note: { en: 'Enter note (optional)', pl: 'Podaj notatkę (opcjonalnie)' },
  admin_confirm_action: { en: 'Confirm action', pl: 'Potwierdź akcję' },
  admin_action_cancelled: { en: 'Action cancelled', pl: 'Akcja anulowana' },

  // ─── REGISTER FORM KEYS ───────────────────────────────────────────────────
  register_step1_desc: { en: 'Tell us about yourself', pl: 'Opowiedz nam o sobie' },
  register_step2_desc: { en: 'Address & Identity Documents', pl: 'Adres i dokumenty tożsamości' },
  register_step3_desc: { en: 'Upload ID & Selfie', pl: 'Prześlij dokument i selfie' },
  register_first_name_placeholder: { en: 'John', pl: 'Jan' },
  register_last_name_placeholder: { en: 'Smith', pl: 'Kowalski' },
  register_email_placeholder: { en: 'your@email.com', pl: 'twoj@email.com' },
  register_phone_placeholder: { en: '+44 7700 900000', pl: '+48 600 000 000' },
  register_password_placeholder: { en: 'Min. 8 characters', pl: 'Min. 8 znaków' },
  register_confirm_password_placeholder: { en: 'Repeat password', pl: 'Powtórz hasło' },
  register_address_placeholder: { en: '25 Canada Square', pl: 'ul. Przykładowa 1' },
  register_city_placeholder: { en: 'London', pl: 'Warszawa' },
  register_postcode_placeholder: { en: 'E14 5LQ', pl: '00-001' },
  register_confirm_password: { en: 'Confirm Password', pl: 'Potwierdź hasło' },
  register_id_document: { en: 'Identity Document', pl: 'Dokument tożsamości' },
  register_id_type: { en: 'Document Type', pl: 'Typ dokumentu' },
  register_upload_id: { en: 'Upload ID Document', pl: 'Prześlij dokument ID' },
  register_upload_instructions: { en: 'Take a clear photo of the front of your document. Accepted formats: JPG, PNG, PDF (max 10MB)', pl: 'Zrób wyraźne zdjęcie przedniej strony dokumentu. Akceptowane formaty: JPG, PNG, PDF (maks. 10MB)' },
  register_selfie: { en: 'Selfie Verification', pl: 'Weryfikacja selfie' },
  register_take_selfie: { en: 'Take or Upload Selfie', pl: 'Zrób lub prześlij selfie' },
  register_selfie_format: { en: 'Hold your ID document next to your face. Accepted: JPG, PNG (max 10MB)', pl: 'Trzymaj dokument ID obok twarzy. Akceptowane: JPG, PNG (maks. 10MB)' },
  register_selfie_tips_title: { en: 'Selfie Tips:', pl: 'Wskazówki do selfie:' },
  register_plan: { en: 'Choose Your Plan', pl: 'Wybierz swój plan' },
  register_creating: { en: 'Creating Account...', pl: 'Tworzenie konta...' },
  register_terms_text: { en: 'I agree to the', pl: 'Zgadzam się z' },
  register_terms_link: { en: 'Terms of Service and Privacy Policy', pl: 'Warunkami usługi i Polityką prywatności' },
  register_success_title: { en: 'Account Created!', pl: 'Konto utworzone!' },
  register_success_subtitle: { en: 'Welcome to CYF24 Bank. Your account has been successfully created.', pl: 'Witamy w CYF24 Bank. Twoje konto zostało pomyślnie utworzone.' },
  register_success_message: { en: 'Account opened successfully', pl: 'Konto otwarte pomyślnie' },
  redirecting: { en: 'Redirecting...', pl: 'Przekierowywanie...' },
  id_type_passport: { en: 'Passport', pl: 'Paszport' },
  id_type_driving_license: { en: "Driver's Licence", pl: 'Prawo jazdy' },
  id_type_national_id: { en: 'National ID Card', pl: 'Dowód osobisty' },

  // ─── ERROR KEYS ───────────────────────────────────────────────────────────
  error_required_fields: { en: 'Please fill in all required fields', pl: 'Wypełnij wszystkie wymagane pola' },
  error_invalid_email: { en: 'Please enter a valid email address', pl: 'Podaj poprawny adres e-mail' },
  error_age_requirement: { en: 'You must be at least 18 years old', pl: 'Musisz mieć co najmniej 18 lat' },
  error_address_required: { en: 'Please fill in your address details', pl: 'Wypełnij dane adresowe' },
  error_password_length: { en: 'Password must be at least 8 characters', pl: 'Hasło musi mieć co najmniej 8 znaków' },
  error_password_mismatch: { en: 'Passwords do not match', pl: 'Hasła nie są zgodne' },
  error_id_required: { en: 'Please upload your identity document', pl: 'Prześlij swój dokument tożsamości' },
  error_selfie_required: { en: 'Please upload a selfie photo', pl: 'Prześlij zdjęcie selfie' },
  error_terms_required: { en: 'You must accept the Terms of Service', pl: 'Musisz zaakceptować Warunki usługi' },
  error_email_exists: { en: 'This email is already registered. Please log in.', pl: 'Ten e-mail jest już zarejestrowany. Zaloguj się.' },
  error_rate_limit: { en: 'Too many attempts. Please wait a moment and try again.', pl: 'Zbyt wiele prób. Poczekaj chwilę i spróbuj ponownie.' },
  error_registration_failed: { en: 'Registration failed. Please try again.', pl: 'Rejestracja nie powiodła się. Spróbuj ponownie.' },

  // ─── PASSWORD STRENGTH ────────────────────────────────────────────────────
  password_too_short: { en: 'Too short', pl: 'Za krótkie' },
  password_weak: { en: 'Weak', pl: 'Słabe' },
  password_moderate: { en: 'Moderate', pl: 'Umiarkowane' },
  password_strong: { en: 'Strong', pl: 'Silne' },
  ssl_encryption: { en: '256-bit SSL Encryption', pl: 'Szyfrowanie SSL 256-bit' },
} as const;

export type TranslationKey = string;

type AnyKey = TranslationKey | (string & Record<never, never>);

interface I18nContextType {
  lang: Lang;
  setLang: (l: Lang) => void;
  t: (key: AnyKey) => string;
}

const I18nContext = createContext<I18nContextType>({
  lang: 'en',
  setLang: () => {},
  t: (k) => (translations as Record<string, {en:string;pl:string}>)[k]?.en ?? String(k),
});

export function I18nProvider({ children }: { children: ReactNode }) {
  const [lang, setLangState] = useState<Lang>(() => {
    return (localStorage.getItem('cyf24_lang') as Lang) ?? 'en';
  });

  const setLang = useCallback((l: Lang) => {
    setLangState(l);
    localStorage.setItem('cyf24_lang', l);
  }, []);

  const t = useCallback(
    (key: AnyKey): string => {
      const rec = (translations as Record<string, {en:string;pl:string}>)[key as string];
      return rec?.[lang] ?? rec?.en ?? String(key);
    },
    [lang]
  );

  return (
    <I18nContext.Provider value={{ lang, setLang, t }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  return useContext(I18nContext);
}